app.controller('HomeController', ['$scope','$http','Config','$timeout','cart','helper','CacheFactory', function($scope,$http,Config,$timeout,cart,helper,CacheFactory){
	
	$scope.newArrivals = [];
	$scope.postcode = '';
	$scope.result = '';
	$scope.base_url = Config.base_url;
	$scope.newsletter_email = '';
	$scope._error = '';
	$scope.cart = cart.getCart();
	$scope.newsletterSubscribed = (CacheFactory.get('appCache').get('newsletterSubscribed')) ? CacheFactory.get('appCache').get('newsletterSubscribed')  : false;
	$http.defaults.headers.common.authorization = Config.api_key;

	$scope.init = function(){
		helper.hideFullLoader();
		$scope.initArrivals();
	}

	$scope.initArrivals = function() {
		if(newArrivalsMain && newArrivalsMain.length > 0){
			$scope.newArrivals = newArrivalsMain;
			$timeout(function () {
				$scope.initOwlSpecialoffersSlider();
				$('#special_offers_loading').fadeOut('slow',function(){$(this).remove();});
				helper.hideTransLoader();
			}, 0);
		}
	}

	// $scope.getProductGroups = function(){
		
	// 	width = 300;
	// 	height = 300;
	// 	helper.showTransLoader();
	// 	query_string = '?brand='+Config.brand_key+'&group-types=new_arrivals&limit=7&width='+width+'&height='+height;

	// 	$http({
	// 	  method: 'GET',
	// 	  url: Config.api_url+'products'+query_string,
	// 	  headers:{
	// 	  	'authorization':Config.api_key
	// 	  }
	// 	}).then(function(response) {
	// 	   	$scope.newArrivals = response.data[0].products;

	// 		console.log($scope.newArrivals)
		   
	// 	   	$timeout(function () {
	// 		    $scope.initOwlSpecialoffersSlider();
	// 		    $('#special_offers_loading').fadeOut('slow',function(){$(this).remove();});
	// 		    helper.hideTransLoader();
	// 		}, 100);

	// 	  }, function(response) {
	// 	    console.log(response);
	// 	  });
	// }

	$scope.initOwlSpecialoffersSlider = function(){
		$("#product_index1").owlCarousel({
	        responsive:{
	            0:{
	                items:1
	            },
	            480:{
	                items:2
	            },
	            768:{
	                items:3
	            },
	            992:{
	                items:4
	            },
	            1200:{
	                items:5
	            }
	        },
	        navigation: true,
	        dots: false,
	        slideSpeed: 300,
	        paginationSpeed: 400,
	        loop: true
	    });

	}

	$scope.calculateShipping = function(form){
		if(form.$valid){
			//send an ajax call to save the message and send an email notification
			console.log($scope.postcode);
			helper.showTransLoader();

			$http({
			  method: 'GET',
			  url: Config.api_url+'quote/postcode-checker?brand='+Config.brand_key+'&delivery-postcode='+$scope.postcode+'&collection-postcode='+$scope.postcode+'&cart-total-weight=0',
			  headers:{
			  	'authorization':Config.api_key
			  }
			}).then(function(response) {
				if(response.data.delivery_zone_status=='enabled'){
				   	if(response.data.delivery_charge==0){
				   		$scope.result = 'We are pleased to confirm that we deliver to your area free of charge.';
				   	}else{
				   		$scope.result = 'We are pleased to confirm that we deliver to your area from as little as £'+response.data.delivery_charge+'.';
				   	}
				}else{
					$scope.result = 'We\'d like to provide an exact price for delivery to this postcode, please contact us.';
				}
				helper.hideTransLoader();
			  }, function(response) {
			    console.log(response);
			});


		}
	}

	$scope.subscribe = function(form){
		$scope._error = '';
		if(form.$valid){
			helper.showTransLoader();
			$http({
			  method: 'POST',
			  data:{'brand':Config.brand_key,'email':$scope.newsletter_email,'discount-type':'percentage','discount-value':10},
			  url: Config.api_url+'newsletter',
			  headers:{
			  	'authorization':Config.api_key
			  }
			}).then(function(response) {
				$scope.newsletter_email = '';
				form.$setPristine(); 
				form.$setUntouched();
				$scope.newsletterSubscribed = true;
				CacheFactory.get('appCache').put('newsletterSubscribed',$scope.newsletterSubscribed);
				helper.hideTransLoader();
			  }, function(response) {
			  	if(response.status==406){
			  		$scope._error = response.data.error;
			  		helper.hideTransLoader();
			  	}
			    console.log(response);
			});
		}
	}

}])